// extracted by mini-css-extract-plugin
module.exports = {"container":"PayoutReceivedScreen_container__1zbSZ","icon":"PayoutReceivedScreen_icon__2sUkH"};